import moment from 'moment';

export const ONE_WEEK = '1W';
export const TWO_WEEKS = '2W';
export const ONE_MONTH = '1M';
export const SIX_MONTHS = '6M';
export const ONE_YEAR = '1Y';
export const INFINITE = 'infinite';

export type Period =
  | typeof ONE_WEEK
  | typeof TWO_WEEKS
  | typeof ONE_MONTH
  | typeof SIX_MONTHS
  | typeof ONE_YEAR
  | typeof INFINITE;

export interface PeriodOperation {
  type: moment.DurationInputArg2;
  duration: moment.DurationInputArg1;
}

export type PeriodOperations = { [key in Period]: PeriodOperation };

export const Operations: PeriodOperations = {
  [ONE_WEEK]: {
    type: 'days',
    duration: 7,
  },
  [TWO_WEEKS]: {
    type: 'days',
    duration: 14,
  },
  [ONE_MONTH]: {
    type: 'months',
    duration: 1,
  },
  [SIX_MONTHS]: {
    type: 'months',
    duration: 6,
  },
  [ONE_YEAR]: {
    type: 'years',
    duration: 1,
  },
  [INFINITE]: {
    type: 'years',
    duration: 100,
  },
};

export const periods: Array<Period> = [ONE_WEEK, TWO_WEEKS, ONE_MONTH, SIX_MONTHS, ONE_YEAR, INFINITE];
